import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { IGetResponse } from './../model/types'

export const getStocks = async (code: string): Promise<IGetResponse> => {
  const { data }:AxiosResponse<IGetResponse> = await api.get(`/action/active/shop/${code}`)
  return data
}
